module.exports = __webpack_public_path__ + "static/media/anime_girl.087b3ee5.jpg";